var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01874 1.52206C7.31826 1.35342 7.6562 1.26483 7.99993 1.26483C8.34367 1.26483 8.6816 1.35342 8.98113 1.52206C9.28065 1.69069 9.53166 1.93368 9.70993 2.22758L9.71185 2.23074L15.3585 11.6574L15.3639 11.6666C15.5386 11.969 15.631 12.3119 15.6319 12.6611C15.6329 13.0104 15.5424 13.3538 15.3695 13.6571C15.1966 13.9605 14.9472 14.2134 14.6462 14.3905C14.3452 14.5676 14.0031 14.6628 13.6539 14.6666L13.6466 14.6667L2.34594 14.6667C1.99674 14.6628 1.65463 14.5676 1.35365 14.3905C1.05266 14.2134 0.803301 13.9605 0.630365 13.6571C0.45743 13.3538 0.36695 13.0104 0.367928 12.6611C0.368906 12.3119 0.461307 11.969 0.635939 11.6666L0.641354 11.6574L6.28992 2.22757C6.46819 1.93368 6.71921 1.69069 7.01874 1.52206ZM7.99993 2.59816C7.88535 2.59816 7.77271 2.6277 7.67287 2.68391C7.57348 2.73987 7.49011 2.82038 7.43074 2.91775L1.78839 12.3372C1.73161 12.4371 1.70158 12.5499 1.70126 12.6649C1.70093 12.7813 1.73109 12.8957 1.78874 12.9969C1.84638 13.098 1.9295 13.1823 2.02983 13.2413C2.12928 13.2998 2.2422 13.3315 2.35753 13.3333H13.6423C13.7577 13.3315 13.8706 13.2998 13.97 13.2413C14.0704 13.1823 14.1535 13.098 14.2111 12.9969C14.2688 12.8957 14.2989 12.7813 14.2986 12.6649C14.2983 12.55 14.2683 12.4371 14.2115 12.3372L8.56993 2.91908C8.56966 2.91864 8.5694 2.91819 8.56913 2.91775C8.50975 2.82038 8.42639 2.73987 8.327 2.68391C8.22716 2.6277 8.11451 2.59816 7.99993 2.59816Z",
    fill: "#C81542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 5.33331C8.36811 5.33331 8.66659 5.63179 8.66659 5.99998V8.66665C8.66659 9.03484 8.36811 9.33331 7.99992 9.33331C7.63173 9.33331 7.33325 9.03484 7.33325 8.66665V5.99998C7.33325 5.63179 7.63173 5.33331 7.99992 5.33331Z",
    fill: "#C81542"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33325 11.3334C7.33325 10.9652 7.63173 10.6667 7.99992 10.6667H8.00659C8.37477 10.6667 8.67325 10.9652 8.67325 11.3334C8.67325 11.7015 8.37477 12 8.00659 12H7.99992C7.63173 12 7.33325 11.7015 7.33325 11.3334Z",
    fill: "#C81542"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertTriangle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-triangle.ecec55e93bf5aa0936a8b9a057c61253.svg";